import { render, staticRenderFns } from "./HomeAwayStandardGeneralSetupForm.vue?vue&type=template&id=7b5bc5f2&scoped=true&"
import script from "./HomeAwayStandardGeneralSetupForm.vue?vue&type=script&lang=js&"
export * from "./HomeAwayStandardGeneralSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5bc5f2",
  null
  
)

export default component.exports